module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "answers-list"
    }
  }, [_c('div', _vm._l((_vm.answersList), function(opt, i) {
    return _c('div', {
      staticClass: "answers"
    }, [_vm._l((opt), function(data) {
      return (_vm.userAnswerList.indexOf(opt) !== -1) ? _c('span', {
        staticClass: "highlight"
      }, [_vm._v(_vm._s(data))]) : _vm._e()
    }), _vm._v(" "), _vm._l((opt), function(data) {
      return (_vm.userAnswerList.indexOf(opt) === -1) ? _c('span', [_vm._v(" ")]) : _vm._e()
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f74534d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Answers.vue
// module id = 30
// module chunks = 0